export default __webpack_public_path__ + "static/media/task.2232828f.png";